import { debounce } from "@mui/material/utils";
import { useMemo } from "react";

export const Debouncer = (toCall: any, delay?: number) => {
  return useMemo(() => debounce(toCall, delay ? delay : 600), [toCall]);
};
